/* eslint-disable prefer-destructuring */
import { sample } from 'effector';
import {
  $curSandTableId,
  $curSandTableIdApi,
  $sceneMapApi,
  $tourData,
  $tourDataApi,
} from '@stores/dataStores';
import domain from '../domain';

export const deleteSandTable = domain.event<string>();

sample({
  source: {
    tourData: $tourData,
    curSandTableId: $curSandTableId,
  },
  clock: deleteSandTable,
  fn: (source, id) => ({ ...source, id }),
}).watch(({ tourData, curSandTableId, id }) => {
  const newSandTableList = (tourData.sandBox ?? []).filter(
    (sandTable) => sandTable.id !== id
  );
  $tourDataApi.update((draft) => {
    draft.sandBox = newSandTableList;
    draft.config.sandBox ??= { showWhenLoad: 1, list: [] };
    draft.config.sandBox.list = (draft.config.sandBox.list ?? []).filter(
      (_id) => _id !== id
    );
    if (draft.config.sandBox.defaultId === id) {
      draft.config.sandBox.defaultId = draft.config.sandBox.list[0];
    }
  });
  $sceneMapApi.update((draft) => {
    draft.forEach((scene) => {
      scene.sandBox ??= { list: [] };
      scene.sandBox.list = (scene.sandBox.list ?? []).filter(
        (_id) => _id !== id
      );
      if (scene.sandBox.defaultId === id) {
        scene.sandBox.defaultId = scene.sandBox.list[0];
      }
    });
  });
  if (curSandTableId === id) {
    $curSandTableIdApi.set(newSandTableList[0]?.id ?? null);
  }
});
